
import React from 'react'
import LeaveTypeListTable from './Components/LeaveTypeListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const LeaveTypeList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Leave Type List</HeadingOne>
                    <AddItemBtn url="add-leave-type" title="Add Leave Type" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <LeaveTypeListTable />
            </div>
        </PageBody>
    );
};

export default LeaveTypeList;
